// 请求接口地址 如果没有配置自动获取当前网址路径
import config from '@/config'
const serverSrc = process.env.NODE_ENV === 'development' ? config.serverSrcDev : `${location.origin}/`
// const serverApiPic = serverSrc + 'adminapi/uploadsGoodsPic'
const serverApiPic = process.env.NODE_ENV === 'development' ? config.serverSrcDev +
                    'adminapi/uploadsPicLocal' : `${location.origin}/` +
                    'adminapi/uploadsPicRemote'
const Setting = {
  serverSrc,
  serverApiPic
}

export default Setting
